import React from 'react';
import { Layout } from '../components/Layout';
import { AnalyticsPanel } from '../components/AnalyticsPanel';

export const TenantAdminDashboard = () => {
  return (
    <Layout title="Tenant Admin Dashboard">
      <div className="space-y-4 sm:space-y-6">
        <div>
          <h1 data-testid="tenant-admin-title" className="text-xl sm:text-2xl font-bold text-indigo-900">Tenant Analytics</h1>
          <p className="text-slate-600 text-xs sm:text-sm">Read-only view of your tenant's performance</p>
        </div>
        <div className="p-3 sm:p-4 bg-indigo-50 rounded-lg border border-indigo-200">
          <p className="text-xs sm:text-sm text-indigo-800">
            <span className="font-semibold">Read-Only Access:</span> You can view analytics and reports for your assigned tenant. Contact Super Admin for changes.
          </p>
        </div>
        <AnalyticsPanel showLeaderboard={true} />
      </div>
    </Layout>
  );
};
